import React from "react";
import { useMsal } from "@azure/msal-react";
import { DefaultButton, PrimaryButton } from "@fluentui/react/lib/Button";
import { Card } from "react-bootstrap";
import { Text } from "@fluentui/react";
import axios from "../configuration/axios";

const LicenseCard = (props) => {
  const { instance } = useMsal();
  const {
    licenseData,
    removeLicense,
    setShowExceptionDialog,
    setExceptionMessage,
    updateLicense,
    setPopUp,
    setToDeleteLicenseData,
    setTokenExpired
  } = props;

  async function removeLicenseById() {
    const config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("msalToken")}`,
      },
    };
    var resData;
    await axios
      .delete(
        axios.defaults.baseURL+ "/License/DeleteById",
        { params: { licenseId: licenseData.licenseId } },
        config
      )
      .then((result) => {
        setTokenExpired(false);
        removeLicense(licenseData.licenseId);
      })
      .catch((error) => {
        if (error.response.status === 401) {
          setTokenExpired(true);
        }
      });
  }

  async function reactivateLicense() {
    const config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("msalToken")}`,
      },
    };
    const bodyParameters = {
      userGuid: licenseData.userGuid,
      userEmail: licenseData.userEmail,
      subscriptionId: licenseData.subscriptionId,
      licenseId: licenseData.licenseId,
    };
    await axios
      .put(
        axios.defaults.baseURL + "/License/ReactivateLicense",
        bodyParameters,
        config
      )
      .then((result) => {
        setTokenExpired(false);
        updateLicense(result.data);
      })
      .catch((error) => {
        setShowExceptionDialog(true);
        setExceptionMessage(error.response.data);
      });
  }

  return (
    <Card
      style={{ width: "50rem", marginTop: "2rem", marginBottom: "-1.5rem" }}
    >
      <Card.Body>
        <Card.Title style={{fontSize:"2.5vh"}}>{licenseData.userEmail}</Card.Title>
        <Text style={{fontSize:"1.5vh"}}>
          License Id: <b>{licenseData.licenseId}</b>
        </Text>{" "}
        <br />
        <Text style={{fontSize:"1.5vh"}}>
          Activation Date: <b>{licenseData.activationDate}</b>
        </Text>
      </Card.Body>
      <Card.Footer style={{ backgroundColor: "white" }}>
        <div>
          <PrimaryButton
            style={{ marginRight: "0.5rem", fontSize:"1.5vh" }}
            text="Reactivate"
            onClick={reactivateLicense}
            hidden={licenseData.isActive}
            />
          <DefaultButton
            style={{ marginRight: "0.5rem", fontSize:"1.5vh" }}
            text="Remove"
            onClick={() => {
              setPopUp(true);
              setToDeleteLicenseData(licenseData);
            }}
          ></DefaultButton>
        </div>
      </Card.Footer>
    </Card>
  );
};

export default LicenseCard;
